import {Icon, styled} from '@innowise-group/ui-kit';

export const CalendarIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  cursor: pointer;
  @media (max-width: 530px) {
    right: 4px;
  }
`;
